const searchAttributes = ['firstName', 'lastName', 'email', 'phoneNumber', 'orgStaffId'] as const;
const listAttributes = [
  'staffId',
  'firstName',
  'lastName',
  'groups',
  'disabled',
  'profileIcon',
  'birthday',
  'orgStaffId',
] as const;
const adminListAttributes = [...listAttributes, 'email', 'phoneNumber', 'slackId'] as const;
const getAttributes = [...listAttributes, 'slackId'] as const;
const adminGetAttributes = [...getAttributes, 'email', 'phoneNumber', 'settings'] as const;
const updateAttributes = [
  'firstName',
  'lastName',
  'slackId',
  'birthday',
  'email',
  'phoneNumber',
  'orgStaffId',
  'settings',
  'profileIcon',
  'groups',
] as const;

export const StaffAttributes = {
  Search: searchAttributes,
  DefaultList: listAttributes,
  AdminList: adminListAttributes,
  DefaultGet: getAttributes,
  AdminGet: adminGetAttributes,
  Update: updateAttributes,
};
